export function useAttachmentUpload() {
  const appAccountStore = useAppAccountStore()

  const uploadAction = computed(() =>
    `${((false && import.meta.env.VITE_ENABLE_PROXY) ? '/proxy' : String('https://test.youpinzhi.net' || '')).replace(/\/$/, '')}/admin/system/storage/attachment/upload`,
  )

  const uploadHeaders = computed(() => (
    appAccountStore.token
      ? { Authorization: `Bearer ${appAccountStore.token}` }
      : {}
  ))

  function normalizeUploadUrl(response: any) {
    return response?.data?.url || response?.data?.file_url || response?.data?.path || ''
  }

  function normalizeUploadRecord(response: any) {
    return response?.data ?? null
  }

  return {
    uploadAction,
    uploadHeaders,
    normalizeUploadUrl,
    normalizeUploadRecord,
  }
}
